import { inject as service } from '@ember/service';
import ApplicationAdapter from 'cio/adapters/application';
import EnvironmentService from 'cio/services/environment';

export default class SetupGuideAdapter extends ApplicationAdapter {
  @service environment!: EnvironmentService;

  // Build URLs in the format: /v1/environments/:id/setup-guide/current
  pathForType(_: string | number) {
    if (!this.environment.current.id) {
      throw new Error('`environment` needs to be initialized before making a request to fetch the setup guide');
    }

    return `environments/${encodeURIComponent(this.environment.current.id)}/setup_guide`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'setup-guide': SetupGuideAdapter;
  }
}
